export default {
  validateCredentials: 'Testuj dane uwierzytelniające',
  credentialsInvalidMessage: 'Nazwa użytkownika lub hasło są nieprawidłowe.',
  credentialsValidMessage: 'Podane dane uwierzytelniające są ważne',
};
